// Apolo IDE — Team Mode toggle (sprint subagents-team, E3-WS1-T01).
//
// Chip do composer que liga/desliga o modo EQUIPE: prompt → líder planeja →
// operários em paralelo → síntese. Template visual do CompareModeToggle
// (aria-pressed, pill) com a lição de hover do Pedro aplicada: hover NEUTRO
// (bg, sem borda colorida); cor de accent SÓ no estado ativo.
//
// O estado mora na pref `team_mode` (localStorage apolo:code:ui, default OFF)
// — mesma vida do compare mode: por-dispositivo, client-side. A exclusão
// mútua com o Compare Mode é responsabilidade do composer que monta os dois.

import { Users } from 'lucide-react';

export default function TeamModeToggle({ active, onToggle }) {
  return (
    <button
      type="button"
      onClick={() => onToggle?.(!active)}
      aria-pressed={active ? 'true' : 'false'}
      aria-label="Alternar modo Equipe (subagents)"
      title="Modo Equipe — o prompt vira um time de subagents (plano → execução paralela → síntese)"
      className={`inline-flex h-6 shrink-0 items-center gap-1 rounded-md border border-transparent px-2 text-xs transition ${
        active
          ? 'bg-apolo-surface2 text-apolo-textPrimary'
          : 'bg-apolo-surface2/40 text-apolo-textSecondary hover:bg-apolo-surface2 hover:text-apolo-textPrimary'
      }`}
    >
      <Users size={11} aria-hidden="true" />
      <span>Equipe</span>
    </button>
  );
}
